export default __webpack_public_path__ + "static/media/Boots of the Farseeker.74bc7c09.jpg";